import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';


@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    public isLoading = new Subject<boolean>();
    public showCookiePolicy = true;

    /**
     * this will show the loader service
     * @returns {void}
     * @memberof LoaderService
     */
    public show(): void {
        this.isLoading.next(true);
    }

    /**
     * this will hide the loader service
     * @returns {void}
     * @memberof LoaderService
     */
    public hide(): void {
        this.isLoading.next(false);
        // HACK for loader testing
        // setTimeout(()=> {
        //         this.isLoading.next(false)
        //     }, 5550000
        // );

    }
}
